import { render, staticRenderFns } from "./CourseGenerator.vue?vue&type=template&id=7bd201e1&scoped=true"
import script from "./CourseGenerator.vue?vue&type=script&lang=js"
export * from "./CourseGenerator.vue?vue&type=script&lang=js"
import style0 from "./CourseGenerator.vue?vue&type=style&index=0&id=7bd201e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd201e1",
  null
  
)

export default component.exports